import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";
import {FOR_YOU_FORM_LABELS} from "../../constants/preferences/application_preferences_labels";
import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";

const getFilledFieldsData = (fields: IPreferencesDefaultValues): {totalQuestions: number; filledSections: string[]} => {
    const filledFieldsData: Record<keyof typeof FOR_YOU_FORM_LABELS, {isFilled: boolean; label: string}> = {
        budget: {
            isFilled: !!fields.budget,
            label: FOR_YOU_FORM_LABELS.budget
        },
        creditPlan: {
            isFilled: fields.creditPlan,
            label: FOR_YOU_FORM_LABELS.creditPlan
        },
        rooms: {
            isFilled: !!fields.rooms && !!(fields.rooms.lower || fields.rooms.upper),
            label: FOR_YOU_FORM_LABELS.rooms
        },
        regionSearch: {
            isFilled: !!fields.regions && fields.regions.length > 0,
            label: FOR_YOU_FORM_LABELS.regionSearch
        }
    };

    const filledSections = Object.values(filledFieldsData).filter((field) => field.isFilled);

    return {
        totalQuestions: Object.keys(filledFieldsData).length,
        filledSections: filledSections.map((field) => field.label)
    };
};

export const hitGtmSurveyBasicSubmit = (fields: IPreferencesDefaultValues, eventCategory: string = "homematch", customLabel?: string) => {
    const {totalQuestions, filledSections} = getFilledFieldsData(fields);

    const gtmData = {
        event: "survey_basic",
        event_action: "submitted",
        event_category: eventCategory,
        event_category2: `${filledSections.length} z ${totalQuestions}`,
        event_category3: filledSections.join(","),
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";
import {FOR_YOU_FORM_LABELS} from "../../constants/preferences/application_preferences_labels";
import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";

const getFilledFieldsData = (fields: IPreferencesDefaultValues): {totalQuestions: number; filledSections: string[]} => {
    const filledFieldsData: Record<keyof typeof FOR_YOU_FORM_LABELS, {isFilled: boolean; label: string}> = {
        budget: {
            isFilled: !!fields.budget,
            label: FOR_YOU_FORM_LABELS.budget
        },
        creditPlan: {
            isFilled: fields.creditPlan,
            label: FOR_YOU_FORM_LABELS.creditPlan
        },
        rooms: {
            isFilled: !!fields.rooms && !!(fields.rooms.lower || fields.rooms.upper),
            label: FOR_YOU_FORM_LABELS.rooms
        },
        regionSearch: {
            isFilled: !!fields.regions && fields.regions.length > 0,
            label: FOR_YOU_FORM_LABELS.regionSearch
        }
    };

    const filledSections = Object.values(filledFieldsData).filter((field) => field.isFilled);

    return {
        totalQuestions: Object.keys(filledFieldsData).length,
        filledSections: filledSections.map((field) => field.label)
    };
};

export const hitGtmSurveyBasicSubmit = (fields: IPreferencesDefaultValues, eventCategory: string = "homematch", customLabel?: string) => {
    const {totalQuestions, filledSections} = getFilledFieldsData(fields);

    const gtmData = {
        event: "survey_basic",
        event_action: "submitted",
        event_category: eventCategory,
        event_category2: `${filledSections.length} z ${totalQuestions}`,
        event_category3: filledSections.join(","),
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(gtmData);
};
